/* Pie página principal del proyecto */

//*react- recursos
  import React, { useState } from "react";
  import { useHistory } from "react-router-dom"; 

//*clases
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faBars, faDesktop, faSitemap, faSquare, } from "@fortawesome/free-solid-svg-icons";

//*datos
  import etiquetasSSC from "../../../datos/json/etiquetasSSC.json";
 //import acercaSit from "../../../datos/json/acercaSitio.json";
  import { Fax } from "@mui/icons-material";

//*interfaces
interface propsPie {
  cnnStore: any;
}
export default function Pie(props: propsPie) {
    //*constantes y variables
    let eti_Lig = etiquetasSSC.Pie.ligas;
    let eti_Eti = etiquetasSSC.Pie.etiquetas;

    const APP_DOCS = process.env.REACT_APP_DOCS + 'Terminosycondiciones_SSC.pdf';
    const API_APP =  process.env.REACT_APP_API_URL;
    const API_INDEX =  process.env.REACT_APP_SERV_URL;
    const API_NAS =  process.env.RREACT_APP_NAS;
/* 
    REACT_APP_ENV = TRAININGDOMINIO
    REACT_APP_API_URL = https://ptracking.snieg.mx/sscapi_training/v1/
    REACT_APP_SERV_URL= https://ptracking.snieg.mx/ssc_training/index.html
    REACT_APP_SERV_HOSTNAME= https://ptracking.snieg.mx/ssc_training/ 
    REACT_APP_IMG =  https://ptracking.snieg.mx/ssc_training/imagenes/
    REACT_APP_DOCS = https://ptracking.snieg.mx/ssc_training/doctos/
    REACT_APP_NAS =  https://ptracking.snieg.mx/ssc_training/docs/
*/


    let acercaSit = [
      { "id": "1", "desc": "Servidor SSC-API:", "desc1": API_APP},
      { "id": "2", "desc": "Carpeta del sitio:", "desc1": API_INDEX},
      { "id": "3", "desc": "Sistema operativo:  ", "desc1": null},
      { "id": "4", "desc": "Conexión front: ", "desc1": "SQL"},
      { "id": "5", "desc": "bd nombre:  ", "desc1": null},
      { "id": "6", "desc": "NAS virtual: ", "desc1": API_NAS},
      { "id": "7", "desc": "filesDecision:   ", "desc1": null},
      { "id": "8", "desc": "logPath:   ", "desc1": null},
      { "id": "9", "desc": "Domain:  ", "desc1": null},
      { "id": "10", "desc": "Esquema:   ", "desc1": null},
      { "id": "11", "desc": "bd ip:  ", "desc1": props.cnnStore},
      { "id": "12", "desc": "Nas Path: ", "desc1": null},
      { "id": "13", "desc": "filesAnalyse:", "desc1": null}
    ]

    let history = useHistory();
    const activaAyuda = () => {  history.push("/Ayuda") }
  

  //*useState
    const [toggle, setToggle] = useState(false);

  return (
    <>
      <div className="background-color-gris padding-2r">

        {/* ligas lineamientos & centro de ayuda & acerca del sitio */}
        <div className="container copy text-right cursorHand">

           {/* lineamientos */}
            <span>
              <a
                href={eti_Lig[0].url}
                target="_blank"
                className="color-Gris2 text-decoration-none noBR "
                title={eti_Lig[0].desc}
              >
                <FontAwesomeIcon icon={faBars} swapOpacity /> {eti_Lig[0].text}{" "}
              </a>
            </span>
          
          &nbsp;&nbsp;&nbsp;

          {/* Ayuda */}
            <span>
              <a onClick={activaAyuda}  className="color-Gris2 text-decoration-none noBR ">
                <FontAwesomeIcon icon={faDesktop} /> {eti_Lig[1].text}</a>
            </span>

          &nbsp;&nbsp;&nbsp;

          {/* Acerca del sitio */}
            <span
              className="color-Gris2  noBR"
              onClick={() => setToggle(!toggle)}
            >
              <FontAwesomeIcon icon={faSitemap} /> {eti_Lig[2].text}
              {toggle && (
                <div id="" className="grisAcerca text-left">
                  <div className="container">
                    <div className="row text-left">
                      <div className="col-md-11 ">
                        <FontAwesomeIcon icon={faSitemap} />&nbsp; Acerca del sitio
                      </div>
                      <div className="col-md-1 text-right color-azul5 cursorHand" title="Cerrar"><b>X</b></div>
                    </div>
                  </div>
                  <div className="text-right"></div>
                  <br />

                  <div className="container">
                    <>
                      {acercaSit.map((item: any) => (
                        <div className="row text-left">
                          <div className="col-md-4 ">{item.desc}</div>
                          <div className="col-md-7 gray">{item.desc1}</div>
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              )}
            </span>
        </div>

        {/* derechos & terminos */}
          <div className="margin-top-2r">
            <div className="text-center">
              {eti_Eti[3].text}
                <a href={APP_DOCS} target="_blank" >
                {" "}
                {eti_Eti[4].text}{" "}
              </a>
            </div>
          </div>
      </div>
    </>
  );
}
